import React from "react";
import review from "./review_color.svg";

const Review_color = ({ isMobile }) => {
  return (
    <img
      width={isMobile ? "36" : "56"}
      height={isMobile ? "36" : "56"}
      src={review}
    />
  );
};

export default Review_color;
